/**
 * Landing Hero Carousel
 * Carousel functionality for landing page hero category tabs
 */

import Flickity from "flickity";

/* global __ */

function landingHeroCarousel(opts) {
  const config = {
    dom: {
      wrapper: "js-landing-hero-section",
      carousel: "landing-page-hero__carousel",
      carouselCell: "js-landing-hero-carousel-cell"
    },
    flickityOpts: {
      mobile: {
        cellAlign: "left",
        prevNextButtons: true,
        wrapAround: true,
        pageDots: true,
        draggable: true,
        dragThreshold: 8,
        lazyLoad: true,
        adaptiveHeight: false,
        setGallerySize: true,
      }
    }
  };

  // Shorthand config
  const c = __.extend(config, opts);

  // global elements
  const $wrappers = document.body.querySelectorAll(`.${c.dom.wrapper}`);
  let view;

  /**
   * Init
   */
  function init() {
    if (!$wrappers?.length) return;
    onWindowResize();
    __.windowResize(onWindowResize);
  }

  /**
  * Responsive functions
  */
  function onWindowResize() {
    // desktop
    __.mq({
      view: 'desktop',
      callback: () => {
        if (view !== 'desktop') {
          view = 'desktop';
          rebuildFlickity();
        }
      },
    });
    // mobile
    __.mq({
      view: 'mobile',
      callback: () => {
        if (view !== 'mobile') {
          view = 'mobile';
          rebuildFlickity();
        }
      },
    });
  }

  /**
   * rebuild flickity
   */
  function rebuildFlickity() {
    [...$wrappers].forEach(($wrapper) => {
      const $carousel = $wrapper.querySelector(`.${c.dom.carousel}`);
      if (!$carousel) return;

      const flickityInstance = Flickity.data($carousel);
      if (flickityInstance) flickityInstance.destroy();

      if (view !== 'mobile') return;

      setTimeout(() => {
        // eslint-disable-next-line no-new
        new Flickity($carousel, c.flickityOpts.mobile);
      }, 250);
    });
  }
  return init();
}

export default landingHeroCarousel;
